import type { BogglePlaygroundSpecialTileSettings } from './tileTypes'

export const DEFAULT_BOGGLE_PLAYGROUND_SPECIAL_TILE_SETTINGS: BogglePlaygroundSpecialTileSettings =
  {
    gold: {
      clearOnUse: false,
      clearOnDisuse: false,
      countAtStart: 0,
      convertXTilesOnSubmit: null,
      enabled: false,
      maximumCount: null,
      persistDuringBoardClears: false,
      replaceWhenCleared: false,
      resetWhenEmpty: false,
      spawnChancePercent: null,
      spawnXTilesOnSubmit: null,
      spawnEveryXTiles: null,
      spreadToAllAdjacentOnUse: false,
      spreadToOneAdjacentOnDisuse: false,
    },
    blue: {
      clearOnUse: false,
      clearOnDisuse: false,
      countAtStart: 0,
      convertXTilesOnSubmit: null,
      enabled: false,
      maximumCount: null,
      persistDuringBoardClears: false,
      replaceWhenCleared: false,
      resetWhenEmpty: false,
      spawnChancePercent: null,
      spawnXTilesOnSubmit: null,
      spawnEveryXTiles: null,
      spreadToAllAdjacentOnUse: false,
      spreadToOneAdjacentOnDisuse: false,
    },
    purple: {
      clearOnUse: false,
      clearOnDisuse: false,
      countAtStart: 0,
      convertXTilesOnSubmit: null,
      enabled: false,
      maximumCount: null,
      persistDuringBoardClears: false,
      replaceWhenCleared: false,
      resetWhenEmpty: false,
      spawnChancePercent: null,
      spawnXTilesOnSubmit: null,
      spawnEveryXTiles: null,
      spreadToAllAdjacentOnUse: false,
      spreadToOneAdjacentOnDisuse: false,
    },
  }
